import React from "react";
import { TabSite } from "./tab-site";
import { RenewableEnergyPurchases } from "./rep/renwable-energy-purchases-page";
import { EmissionsAllocationTab, IntensityTab } from "./components";
import { TabConfig } from "./types";

export const BASE_TABS_CONFIG: TabConfig[] = [
  { label: 'Active', value: 'Active', content: <TabSite state="active" /> },
  { label: 'Inactive', value: 'Inactive', content: <TabSite state="inactive" /> },
  { label: 'Renewable Energy Purchases', value: 'Renewable Energy Purchases', content: <RenewableEnergyPurchases /> },
  { label: 'Intensity', value: 'Intensity', content: <IntensityTab /> },
  { label: 'Emissions Allocation', value: 'Emissions Allocation', content: <EmissionsAllocationTab />, adminOnly: true },
];